<jmkw-button
  #button
  [id]="id"
  [iconName]="iconName"
  [buttonText]="buttonText"
  [automationKey]="automationKey"
  [tooltipText]="tooltipText || ''"
  [active]="$active()"
  [hover]="$hover()"
  [disabled]="$disabled()"
  (onClick)="onClickHandler($event, button)"
>
  {{ buttonText }}
</jmkw-button>
